<template>
	<b-jumbotron>
		<template #header>
			<img src="@/assets/logo.png" width="480px"/>
			{{ $t('countrySelection.tdb') }}
		</template>
		<Notifications />
		<LoadingIndicator />
		<p>{{ $t('countrySelection.select') }}</p>
		<ol id="CountrySelection">
			<li
				v-for="country in countries"
				:key="country.id"
			>
				<b-link
					@click="select(country)"
				>
					<img :src="images[country.data.code.toLowerCase()]" width="160" />
					<p>{{ country.data.labels | toLocale }}</p>
				</b-link>
			</li>
		</ol>
	</b-jumbotron>
</template>

<script>
import { getFlagImages } from '@/util/flags.js';
import LoadingIndicator from './loading-indicator.vue';
import Notifications from './notifications.vue';
/*
 * selection of country
 */
export default {
	name: 'CountrySelectionLayout',
	components: {
		LoadingIndicator,
		Notifications
	},
	computed: {
		countries() {
			return this.$store.getters['country/countriesForSelection'];
		},
		images() {
			return getFlagImages();
		}
	},
	watch: {
		countries(nv) {
			if (nv.length === 1) {
				this.select(nv[0]);
			}
		}
	},

	methods: {
		getBestUrl(country) {
			let list = country.data.domains;
			let current = document.location.hostname;
			let filtered = list.filter(e => e.includes(current));
			let base = filtered.length > 0 ? filtered[0] : list[0];
			if (!base) return '';
			return `${document.location.protocol}//${base}${document.location.hash}`;
		},
		select(country) {
			let url = this.getBestUrl(country);
			console.log(country, url);
			window.location.href = url;
		}
	}
};
</script>

<style scoped lang="scss">
#CountrySelection {
	list-style: none;
	display: flex;
	flex-flow: row wrap;
	> li {
		width: 200px;
		height: 160px;
		margin: 2rem;
		> a {
			display: flex;
			flex-flow: column nowrap;
			height: 100%;
			align-items: center;
			justify-content: space-between;
			> img {
				outline: 1px solid #aaa;
			}
			> p {
				margin: 0;
			}
		}
	}
}
.jumbotron {
	max-width: 960px;
	margin: 0 auto;
	// background-color: #ccc;
}
h1 > img {
	border: none;
	display: block;
	margin: 0 auto 24px;
}
.display-3 {
	font-size: 4rem;
}

</style>
